<label class="switch">
    <input
        type="checkbox"
        [(ngModel)]="toggleModel"
        [checked]="checked"
        (change)="onModelChange($event)"
    />
    <span class="slider"></span>
</label>
